import { render, staticRenderFns } from "./timeline.vue?vue&type=template&id=1479836a&scoped=true&"
import script from "./timeline.vue?vue&type=script&lang=js&"
export * from "./timeline.vue?vue&type=script&lang=js&"
import style0 from "./timeline.vue?vue&type=style&index=0&id=1479836a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479836a",
  null
  
)

export default component.exports